import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const LinkStyled = styled(Link)`
  color: #545454;
`;

export const LogoTextStyled = styled.span`
  font-weight: 500;
  font-size: 17px;
  margin-left: 10px;
  color: #fff;
`;
